import { useQuery } from "@tanstack/react-query";
import fetchWrapper from "../../../../api/fetchWrapper";
import { ENDPOINT } from "../../../../api/endpoint";
import { useEffect, useMemo, useRef, useState } from "react";
import { AuditLogFilterType } from "../../../../interface";

const useAuditFilterLogDetails = (filters: AuditLogFilterType,dataLimit:number[],nextPageKey:any) => {
  const [auditLogData, setAuditLogData] = useState<any>([]);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [nextRowsPageKey, setNextRowsPageKey] = useState<string | undefined>('');
  const prevKeyRef=useRef<string | undefined>('');
  const endpoint = useMemo(() => {
    return ENDPOINT.GET_AUDIT_LOGS
  }, []);

  const isFilterValid = useMemo(() => {
    return (
      filters?.startDate?.trim() !== "" &&
      filters?.endDate?.trim() !== "" &&
      endpoint !== "" &&
      dataLimit !== null
    );
  }, [filters, endpoint, dataLimit ]);



  const formBody = useMemo(() => {
    const filter = {
      dateRange: filters.dateRange,
      dateRangeText: filters.dateRange,
      startDate: filters.startDate,
      endDate: filters.endDate,
      limit: dataLimit,
      nextPageKey:nextPageKey.val || ""
    };
    return filter;
  }, [filters,dataLimit,nextPageKey]);

  const {
    data = [],
    isLoading: queryLoading,
    error,
    isError
  } = useQuery({
    queryKey: ["auditLogData", filters,dataLimit, endpoint],
    enabled: isFilterValid,
    queryFn: async ({ signal }) => {
      const response = await fetchWrapper(endpoint, {
        method: "POST",
        body: formBody,
        signal,
      });

      if (!response || response.status === 500) {
        throw new Error("Internal Server Error");
      }

      return response;
    },
    retry: false,
    refetchOnWindowFocus: false
  });

  useEffect(() => {
    if (!queryLoading) {
      if (data?.message || isError ) {
        setAuditLogData([]);
      } else {
       const isEmpty = (a: any): boolean => Array.isArray(a) && a.every(isEmpty);
       const newData = isEmpty(data.auditResults) === false?data.auditResults:[];
       console.log(Array.isArray(newData));
       setAuditLogData((prev: any) =>
         dataLimit[0] !== 0? [...prev, ...newData] : Array.isArray(newData)===true?newData:[]
       );
       setNextRowsPageKey(data.pagination?.nextPageKey)
       prevKeyRef.current=data.pagination?.prevPageKey
      }
    }
  }, [data, dataLimit, queryLoading,error, isError]);


  useEffect(() => {
    if (!queryLoading) setTotalCount(data.pagination?.totalAuditLogs);
  }, [data, queryLoading]);

  const initVal = useMemo(
    () => ({
      auditLogData: [],
      isLoading: false,
      isError: false,
      errorData: null,
      totalCount: 0,
      nextRowsPageKey:"",
      prevPageKey:""
    }),
    []
  );

  return !isFilterValid
    ? initVal
    : {
        auditLogData,
        isLoading: queryLoading,
        isError,
        totalCount,
        nextRowsPageKey,
        prevPageKey:prevKeyRef
      };
};


export default useAuditFilterLogDetails;
